import http from "./create_axios";

const STAT_TOKEN_KEY = "statToken";

class Stat {
	getToken() {
		try {
			return localStorage.getItem(STAT_TOKEN_KEY) || "";
		} catch (e) {
			return "";
		}
	}

	setToken(token) {
		try {
			if (token) {
				localStorage.setItem(STAT_TOKEN_KEY, token);
			} else {
				localStorage.removeItem(STAT_TOKEN_KEY);
			}
		} catch (e) {
			/* ignore */
		}
	}

	authHeaders() {
		return {"x-stat-token": this.getToken() || ""};
	}

	auth(user, pass) {
		return http.post("/api", {type: "stat_auth", user, pass}, {withCredentials: true});
	}

	logout() {
		return http.post("/api", {type: "stat_logout"}, {headers: this.authHeaders(), withCredentials: true});
	}

	getFilesInfo() {
		return http.post("/api", {type: "stat_files_info"}, {headers: this.authHeaders(), withCredentials: true});
	}

	fileUrl(fileName) {
		const base = (http.defaults.baseURL || window.location.origin).replace(/\/$/, "");
		return `${base}/stat/${fileName}`;
	}
}

export default new Stat();
